import { Component } from 'react';
import lodash from 'lodash';
import classnames from 'classnames';
import { LoadingStatus } from 'components/common/LoadingStatus/LoadingStatus';
import styles from './Events.scss';
import { EventSlat } from '../components/Slat';
import { SignatureStatus } from '../components/SignatureStatus';
import { formatDate } from 'pages/events/util';

const DEFAULT_EVENT_DISPLAY_VALUE = 'Not Specified';

export class EventsList extends Component {
    select(event) {
        const { hasManageEvents } = this.props;
        if(hasManageEvents) {
            const { onSelect } = this.props;
            onSelect(event);
            this.props.showPanel(true);
        }
    }

    getEventRows(){
        const { events, timezoneOffset, loading, icfLanguages, hasManageEvents } = this.props;
        if(loading){
            return null;
        }

        const eventList = events.map(event => {
            const eventTypeSlat = EventTypeToSlatMap[event.eventType];
            if(eventTypeSlat){
                return eventTypeSlat({
                    event: event,
                    icfLanguages: icfLanguages,
                    onClick: this.select.bind(this, event),
                    timezoneOffset: timezoneOffset,
                    hasManageEvents
                });
            }
            else {
                return EventSlat(event, this.select.bind(this, event));
            }
        });
        return eventList;
    }

    render() {
        const { loading, complion4FlagEnabled } = this.props;
        return (
            <div className={styles.listAreaContainer} data-cy="EventsList">
                <ul className={styles.listArea} data-cy="EventsList-ul">
                    <LoadingStatus loading={loading} itemName={complion4FlagEnabled ? 'binder events' : 'study events'}/>
                    {this.getEventRows()}
                </ul>
            </div>
        );
    }
}

export const MonitorVisitEventRow = ({event, onClick, timezoneOffset, hasManageEvents}) => {
    return (
        <li key={event.id} onClick={onClick} className={classnames(
            styles.event,
            { [styles.disabledEvent]: !hasManageEvents, }
        )} data-cy={'EventsList' + event.id}>
            <ul className={styles.eventValues} data-cy={'ul-EventsList' + event.id}>
                <li className={styles.eventValueSet}>
                    <p className={styles.eventType} data-cy={'ul-EventsList' + event.id+'-eventType'}>
                        { event.eventType }
                    </p>
                    <SignatureStatus
                        total={event.signatureRequestCount}
                        pending={event.signatureRequestPending}
                        canceled={event.signatureRequestCanceled}/>
                </li>
                <li className={styles.eventValueSet}>
                    <p className={styles.eventValueTitle}>
                  Site Visit Date
                    </p>
                    <p className={styles.eventValue} data-cy={'ul-EventsList' + event.id+'-formatDate'}>
                        { formatDate(event.dateOfVisit) || DEFAULT_EVENT_DISPLAY_VALUE }
                    </p>
                </li>
                <li className={styles.eventValueSet}>
                    <p className={styles.eventValueTitle}>
                Visit Type
                    </p>
                    <p className={styles.eventValue} data-cy={'ul-EventsList' + event.id+'-monitorVisitType'}>
                        { event.monitorVisitType || DEFAULT_EVENT_DISPLAY_VALUE }
                    </p>
                </li>
                <li className={styles.eventValueSet}>
                    <p className={styles.eventValueTitle}>
                  Monitor
                    </p>
                    <p className={styles.eventValue} data-cy={'ul-EventsList' + event.id+'-displayName'}>
                        { lodash.get(event, 'monitor.displayName', '') || DEFAULT_EVENT_DISPLAY_VALUE }
                    </p>
                </li>
                <li className={styles.eventValueSet}>
                    <p className={styles.eventValueTitle}>
                Created By
                    </p>
                    <p className={styles.eventValue} data-cy={'ul-EventsList' + event.id+'-createdBy'}>
                        {event.createdBy.displayName || DEFAULT_EVENT_DISPLAY_VALUE }
                    </p>
                </li>
            </ul>
        </li>
    );
};

export const ICFVersionChangeEventRow = ({ event, onClick, timezoneOffset, icfLanguages, hasManageEvents}) => {
    return (
        <li key={event.id} onClick={onClick} className={classnames(
            styles.event,
            { [styles.disabledEvent]: !hasManageEvents, }
        )}  data-cy={'ICFVersionChangeEventRow' + event.id}>
            <ul className={styles.eventValues} data-cy={'ul-ICFVersionChangeEventRow' + event.id}>
                <li className={styles.eventValueSet}>
                    <p className={styles.eventType} data-cy={'p-ICFVersionChangeEventRow' + event.id}>{ event.eventType }</p>
                    <SignatureStatus
                        total={event.signatureRequestCount}
                        pending={event.signatureRequestPending}
                        canceled={event.signatureRequestCanceled}/>
                </li>
                <li className={styles.eventValueSet}>
                    <p className={styles.eventValueTitle}>IRB Approval Date</p>
                    <p className={styles.eventValue} data-cy={'formatDate-ICFVersionChangeEventRow' + event.id}>
                        { formatDate(event.irbApprovalDate) || DEFAULT_EVENT_DISPLAY_VALUE }
                    </p>
                </li>
                <li className={styles.eventValueSet}>
                    <p className={styles.eventValueTitle}>ICF Type</p>
                    <p className={styles.eventValue} data-cy={'icfType-ICFVersionChangeEventRow' + event.id}>
                        { event.icfType || DEFAULT_EVENT_DISPLAY_VALUE }
                    </p>
                </li>
                <li className={styles.eventValueSet}>
                    <p className={styles.eventValueTitle}>Reconsent Required</p>
                    <p className={styles.eventValue} data-cy={'reconsentRequired-ICFVersionChangeEventRow' + event.id}>
                        { event.reconsentRequired || DEFAULT_EVENT_DISPLAY_VALUE }
                    </p>
                </li>
                <li className={styles.eventValueSet}>
                    <p className={styles.eventValueTitle}>Created By</p>
                    <p className={styles.eventValue} data-cy={'displayName-ICFVersionChangeEventRow' + event.id}>
                        {event.createdBy.displayName || DEFAULT_EVENT_DISPLAY_VALUE }
                    </p>
                </li>
            </ul>
        </li>
    );
};

export const EventTypeToSlatMap = {
    'Monitor Visit': MonitorVisitEventRow,
    'ICF Version Change': ICFVersionChangeEventRow,
};
